import * as yup from 'yup';
import i18next from 'i18next';
import { messages } from './messages';

export const getValidationSchema = () =>
  yup.object().shape({
    firstName: yup.string().required(i18next.t(messages.thisFieldIsRequired())),
    lastName: yup.string().required(i18next.t(messages.thisFieldIsRequired())),
    relationship: yup
      .string()
      .required(i18next.t(messages.thisFieldIsRequired())),

    email: yup
      .string()
      .required(i18next.t(messages.thisFieldIsRequired()))
      .email(i18next.t(messages.invalidEmail())),
  });
